import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCustomerExistsModal } from '../actions/modalActions'
import { setMessageModal } from '../../actions/generalActions'
import { getTranslation } from '../../actions/dataActions'
import * as resource from '../../constants/Resources'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import CustomerExistsListItem from '../../components/CustomerExistsListItem'

class CustomerExistsModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.takeOverTap = this.takeOverTap.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
        this.createCustomerModalCallback = this.createCustomerModalCallback.bind(this);
        
        this.state = {
            shouldRefresh: false,
        };
    }

    componentDidUpdate() {
        if (this.state.shouldRefresh) {
            this.showCustomers();

            this.setState({ 
                shouldRefresh: false
            });
        }
    }

    cancelTap() {
        this.props.setCustomerExistsModal([], false, 'default');
    }

    takeOverTap(){
        this.processTouchTap(null);
    }

    createCustomerModalCallback(customer) {
        if(customer){
            this.processTouchTap(customer);
            return;
        }
        this.setState({ 
            shouldRefresh: true
        });
    }    

    showCustomers() {
        this.props.showCustomerExists(null);
    }

    processTouchTap(customer) {
        const callback = this.props.customerExistsModal.callback;
        const dispatch = this.props.customerExistsModal.dispatch;

        let callbackParams = [customer];

        if (this.props.customerExistsModal.callbackparams !== undefined) {
            this.props.customerExistsModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.props.setCustomerExistsModal([], false, 'default');

        if (callback !== null) {
            if (dispatch !== undefined && dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    render() {
        const newList = this.props.customerExistsModal.listvalues || [];
        return (
            <Modal className='customerExistsModal'
                contentLabel=""
                isOpen={this.props.customerExistsModal.show}
                style={properties.customerExistsModalStyle}
            >
                <div className="customerExistsModal_header">
                    <div className="header_top">
                        <p>
                        {this.props.getTranslation(resource.EXISTING_CUSTOMERS_FOUND)}
                        </p>
                        <p className="info">
                        {this.props.getTranslation(resource.IMPORT_ID_DATA_WARNING_EXISTING_CUSTOMERS)}
                        </p>
                    </div>
                </div>
                <div className="customerExistsModal_content">
                    <div>
                        <div className="customerList" >
                            {
                                newList.slice(0, 50).sort((a, b) => (a.Name > b.Name) ? 1 : -1).map(val =>
                                    <CustomerExistsListItem
                                        key={val.CustomerId}
                                        Customer={val}
                                        Callback={this.processTouchTap}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="customerExistsModal_footer">
                    <button className="btnCancel" onClick={this.cancelTap} >
                        {this.props.getTranslation(resource.CANCEL)}
                    </button>
                    <button className="btnTakeOver" onClick={this.takeOverTap} >
                        {this.props.getTranslation(resource.TAKE_OVER)}
                    </button>
                </div>

            </Modal>
        )
    }
}

CustomerExistsModal.propTypes = {
}


function mapStateToProps(state) {
    return {
        customerExistsModal: state.modalState.customerExistsModal,
    }
}

export default connect(mapStateToProps, {
    setCustomerExistsModal,
    setMessageModal,
    getTranslation
})(CustomerExistsModal)



// WEBPACK FOOTER //
// src/modal/components/CustomerExistsModal.jsx